export default __webpack_public_path__ + "static/media/CivilEng_IMG-Earthwork.729730a6.png";